// extracted by mini-css-extract-plugin
export default {"specialsul":"_3WcpuQ5aJzyabk5n5-7x1l","special":"_3_nTGBxzfVfGuU4wZooLXy","promoRow":"_2GmkI9rpoDTJ3NwoZcQ5Ki","expiration":"_2EW3SNvPay1jMWB7TxJkq8"};